import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as R from "ramda"
import { useAppDispatch } from "../../../../../hooks/hooks";
import storePersist from "../../../../../redux/storePersist";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table";
import { selectDbaRegistriesListItems } from "../../../../../redux/dba-registries/selector";
import { dbaRegistries } from "../../../../../redux/dba-registries/action";

const ShipXRegistries = () => {
    const dispatch = useAppDispatch()
    const librariesItems = storePersist?.get("library")?.current;
    const navigate = useNavigate()
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const dbnpregistriesItems = useSelector(selectDbaRegistriesListItems)
    const [columnDefs, setColumnDefs] = useState({});
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
         
            { field: 'DBNPName', headerName: 'DBNP Name'},
             { field: 'GlobalDBARegistryName', headerName: 'Global DBARegistry Name'},
            { field: 'name_of_authorised_signatory', headerName: 'Name Of Authorised Signatory', searchField: 'name_of_authorised_signatory', sortable: true, filter: true, filterType: 'text' },
            { field: 'address_of_authorisedSignatory', headerName: 'Address Of AuthorisedSignatory' },
            {
                field: 'ops_no', headerName: 'ops Number',valueFormatter: getOpsName 
            },
            { field: 'email_id', headerName: 'Email', searchField: 'email_id', sortable: true, filter: true, filterType: 'text' },
            { field: 'mobile_no', headerName: 'Mobile No' },
            { field: 'country', headerName: 'country' },
            { field: 'subscriber_id', headerName: 'Subscriber' },
            { field: 'unique_key_id', headerName: 'Unique Key' },
            { field: 'IsPartnerNetwork', headerName: 'IsPartnerNetwork',cellRenderer: 'yesNoRenderer' },
                 { field: 'IsOnBoardedInShipX', headerName: 'IsOnBoardedInShipX',cellRenderer: 'yesNoRenderer' },
        ]);
    }
    const getOpsName = (storeNameId: any) => {
        const StoreNameList = R.find(
          (storeName: any) => parseInt(
            storeName.Value,
            10
          ) === parseInt(
            storeNameId,
            10
          ),
          librariesItems?.Ops_no
        )
        return StoreNameList ? StoreNameList.Description : ''
      }
    const handleAdd = () => {
        navigate(`${0}`)
    }

    const handleEdit = (data: any) => {

        navigate(`${data?.Id}`)
    }

    const handleDelete = (data: any) => {
        dispatch(dbaRegistries.delete({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dod-cloud/dba-registries/delete`,
            entity: 'dbaRegistries',
            jsonData: {
                Records: [
                    {
                        Id: data?.Id
                    }
                ]
            }
        })).then(() => {
            dispatch(dbaRegistries.list({
                url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dod-cloud/dba-registries/list`,
                entity: 'dbaRegistries',
                jsonData: {
                   
    "Context": {},
  "Records" : [{
        "IsOnBoardedInShipX": true
  }],
  "Pagination":{
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
  }
        }}))
        });
    }
    const fetchDbnpRegistries = () => {

        dispatch(dbaRegistries.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dod-cloud/dba-registries/list`,
            entity: 'dbaRegistries',
            jsonData: {
                 "Context": {},
  "Records" : [{
     "IsOnBoardedInShipX": true
  }],
  "Pagination":{
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
  }
            }
        }))

    }

    useEffect(() => {
        createColumnDefs()
        fetchDbnpRegistries()
    }, [pageData, pageSize])

         const handleCreateDefaultDBARegistries = async () => {
            await dispatch(dbaRegistries.resetAction({ actionType: 'create' }))
            await dispatch(dbaRegistries.create({
              url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dod-cloud/dba-registries/create-by-default`,
              entity: 'dbaRegistries',
              jsonData:
              {
                "Context": {},
                "Records": [ 
                    {}
                ]
              }
            })).then(() => {
             handleReloadData()
            });
          }
    const additionButtons: any = [
        {
          svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
            <title>Create Default DBA Registry </title>
            <path 
              d="M12 2v2a8 8 0 1 1-7.11 11H2a10 10 0 1 0 10-10zM12 22v-2a8 8 0 1 1 7.11-11H22a10 10 0 1 0-10 10z" 
              fill="none" 
              stroke="currentColor" 
              stroke-width="2" 
              stroke-linecap="round" 
              stroke-linejoin="round" 
            />
          </svg>,
          callback: () => handleCreateDefaultDBARegistries(),
        },
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
                    <title>Reload this table</title>
                    <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>,
            // name: 'Reload',
            callback: () => handleReloadData(),
        }
    ];

    const handleReloadData = () => {
        fetchDbnpRegistries();
    }

    const handleSearch = (data: any) => {
        console.log('Search data', data)
        let searchCriteria = {};
        if (data?.column) {
            searchCriteria = [{
                FieldName: data?.column,
                FieldText: data?.column,
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        } else {
            searchCriteria = [{
                FieldName: "Name",
                FieldText: "Name",
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        }
        dispatch(dbaRegistries.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dod-cloud/dba-registries/list`,
            entity: 'dbaRegistries',
            jsonData: {
                 "Context": {},
  "Records" : [{
     "IsOnBoardedInShipX": true
  }],
  "Pagination":{
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
                "Searches": searchCriteria
  }
            }
        }));
    }

    const handleSelect = (item: any, checked: any) => {
        console.log("Item", checked, item)
    }

    const handleSelectAll = (items: any[], checked: any) => {
        console.log("Items count", checked, items?.length)
        console.log('items', items)
    }

    return (
        <>
            {dbnpregistriesItems?.isLoading ? <PageLoader /> :
                <Table columnData={columnDefs} rowData={dbnpregistriesItems?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
                    enableFilter={true} onSearch={handleSearch} onSelect={handleSelect} onSelectAll={handleSelectAll}
                    paginationData={dbnpregistriesItems?.result?.pagination} onEdit={handleEdit}
                    additionButtons={additionButtons} headingName="DBA Registries" />
            }
        </>
    );
};

export default ShipXRegistries;


